import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useSession } from './session';

/**
 * Auth guard STUB (build/07 Phase 0).
 *
 * Sends anyone without a session to the login screen, remembering where they
 * were headed so the deep link survives the detour. That makes login the
 * console's start screen.
 *
 * Phase 4 replaces the session stub behind `useSession` with real JWT handling
 * — token in memory, silent refresh on 401, `requireRole` gating — and this
 * component keeps its shape.
 *
 * IMPORTANT: this is a UI convenience only. Authorisation is enforced
 * SERVER-side (build/06 §5) — a redirect is not a security control, and this
 * component must never become the only thing standing between a user and an
 * authoring route.
 */
export function AuthGuard({ children }: { children: ReactNode }) {
  const { user } = useSession();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return <>{children}</>;
}
